import type { Labels, GridCommonProps } from '@@partner:types:app'

import React from 'react'
import { formatDate } from '@@partner:helpers/util'

import { Link } from 'react-router-dom'
import { Table, Button, Tag } from 'rsuite'
import CommonStatusLabel from '@components/common/CommonStatusLabel'

const { Column, HeaderCell, Cell } = Table

export interface LabelsTableProps extends GridCommonProps<Labels> {}

const LabelsTable: React.FC<LabelsTableProps> = ({
  tableSort,
  onSortColumn,
  items,
  generateEditUrl,
  loading
}) => {
  return (
    <Table
      autoHeight
      affixHeader
      loading={loading}
      data={items}
      sortColumn={tableSort.fieldName}
      sortType={tableSort.sortType}
      onSortColumn={onSortColumn}
      rowHeight={100}
    >
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>ИД</HeaderCell>
        <Cell dataKey="id"></Cell>
      </Column>
      <Column flexGrow={1} verticalAlign="middle">
        <HeaderCell>Лейбл</HeaderCell>
        <Cell dataKey="image" style={{ padding: 0, minHeight: '150px' }}>
          {(rowData) => (
            <img
              src={rowData.image.url}
              alt=""
              style={{ maxHeight: '100px' }}
            />
          )}
        </Cell>
      </Column>
      <Column flexGrow={1} verticalAlign="middle">
        <HeaderCell>Заголовок</HeaderCell>
        <Cell dataKey="name"></Cell>
      </Column>
      <Column flexGrow={2} verticalAlign="middle">
        <HeaderCell>Техническое название</HeaderCell>
        <Cell dataKey="system_name"></Cell>
      </Column>
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>Статус</HeaderCell>
        <Cell dataKey="status">
          {(rowData) => <CommonStatusLabel status={rowData.status} />}
        </Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Срок действия (от/до)</HeaderCell>
        <Cell>
          {(rowData) => {
            return (
              <>
                {rowData.activeFrom && rowData.activeUntil && (
                  <>
                    <Tag>{formatDate(new Date(rowData.activeFrom))}</Tag>
                    <span>/</span>
                    <Tag>{formatDate(new Date(rowData.activeUntil))}</Tag>
                  </>
                )}
                {rowData.activeFrom && !rowData.activeUntil && (
                  <>
                    <span>С </span>
                    <Tag>{formatDate(new Date(rowData.activeFrom))}</Tag>
                  </>
                )}
                {!rowData.activeFrom && rowData.activeUntil && (
                  <>
                    <span>до </span>
                    <Tag>{formatDate(new Date(rowData.activeUntil))}</Tag>
                  </>
                )}
                {!rowData.activeFrom && !rowData.activeUntil && (
                  <Tag color="red">Истёк</Tag>
                )}
              </>
            )
          }}
        </Cell>
      </Column>
      <Column flexGrow={2} fixed="right" verticalAlign="middle">
        <HeaderCell>Управление</HeaderCell>
        <Cell>
          {(label: Labels) => (
            <>
              {generateEditUrl && (
                <Button
                  appearance="primary"
                  color="cyan"
                  as={Link}
                  to={generateEditUrl(label?.id)}
                  size="xs"
                >
                  Изменить
                </Button>
              )}
            </>
          )}
        </Cell>
      </Column>
    </Table>
  )
}

export default LabelsTable
